import { connect } from 'react-redux';
import PushNotification from './push_notification';
import { loadAdvisor } from '../../actions/advisors';
import withPGTranslation from '../../config/withPGTranslation';
import { loadHomePage } from '../../actions/home_page';

const mapStateToProps = ({
  chat, user: { user }, advisors
}) => ({
  needToHandle: !chat?.state,
  userbadgeCounters: user?.badgeCounters,
  advisors
});

export default connect(
  mapStateToProps,
  {
    loadAdvisor,
    loadHomePage
  }
)(withPGTranslation(PushNotification));
